<template>
    <b-modal id="modal-anuencia-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalAnuenciaDetalhe">
       <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Pedido de Anuência  nº {{ nrPedido }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center"
                    style="
                        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                        width: 100%;
                        height: 100%;
                        display: block;
                        z-index: 10002;
                        margin: 0;
                    "
                >
                    <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Text Centered"
                    ></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
                <b-row>
                    <b-col class="col-xl-6 col-12 card-column-left">
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Solicitante</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome:</b> {{ solicitante.nm_solicitante }}</span>
                                <span><b>Documento:</b> {{ solicitante.documento_solicitante }}</span>
                                <span><b>Telefone:</b> {{ solicitante.telefone_solicitante }}</span>
                                <span><b>Celular:</b> {{ solicitante.celular_solicitante }}</span>
                                <span><b>E-mail:</b> {{ solicitante.nm_email_solicitante }}</span>
                            </div>
                        </div>
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Cartório</h3>
                            </div>
                            <div class="modal-card-body">                           
                                <span><b>Nome:</b> {{ cartorio.nome_cartorio }}</span>
                                <span><b>CNPJ:</b> {{ cartorio.documento_cartorio }}</span>
                                <span><b>Telefone:</b> {{ cartorio.telefone_cartorio }}</span>
                                <span><b>E-mail:</b> {{ cartorio.email_cartorio }}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 card-column-right">
                        <div class="modal-card pb-3 pt-2">
                            <div class="modal-card-header">
                                <h3>Dados da Anuência</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Anuência:</b> {{ anuencia.cd_anuencia }}</span>
                                <span><b>Dt. Solicitação:</b> {{ anuencia.dt_cadastro  }}</span>
                                <span><b>Status:</b> {{ anuencia.ds_status }}</span>
                                <span><b>Valor Emol. para Cancelamento:</b> {{ anuencia.vl_custas }}</span>
                                <span><b>Download Anuência: <a href="#" @click="downloadPDF(anuencia.cd_anuencia, 'anuencia')" class="text-danger"><font-awesome-icon class="text-danger" size="1x" icon="file-pdf" /> Anuência</a></b></span>
                                <span v-if="anuencia.anexo_anuencia"><b>Download Anexo: <a href="#" @click="downloadPDF(anuencia.cd_anuencia, 'anexo')" class="text-info"><font-awesome-icon class="text-info" size="1x" icon="file-alt" /> Anexo</a></b></span>
                                <span><b>Origem: </b><span style="color:red;font-weight:bold;">{{(anuencia.ic_origem_anuencia == 1) ? 'Manual' : 'Automática'}}</span></span>
                                <template v-if="anuencia.cd_status == 3 || anuencia.cd_status == 5" >
                                    <hr />
                                    <span style="color:red;"><b>Anuência Reprovada</b></span>
                                    <span> <b>Motivo Recusa:</b> {{ anuencia.motivo_recusa }}</span>
                                </template>
                            </div>
                        </div>
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Título</h3>
                            </div>
                            <div class="modal-card-body">                     
                                <span><b>Nosso Numero:</b>  {{ titulo.nm_nosso_numero }}</span>
                                <span><b>Nº Titulo:</b>  {{ titulo.nm_nr_titulo }}</span>
                                <span><b>Valor Título: {{ titulo.vl_titulo }}</b> </span>
                                <span><b>Valor Protestado: {{ titulo.vl_protesto }}</b> </span>
                                <span><b>Devedor:</b> {{ titulo.nm_devedor }}</span>
                                <span><b>Doc. Devedor:</b>  {{ titulo.nm_nr_documento_devedor }}</span>
                                <hr/>
                                <span><b>Nº Protocolo:</b> {{ titulo.nm_nr_protocolo }}</span>
                                <span><!-- SPACER --></span>
                                <span><b>Data Protocolo:</b> {{ titulo.dt_protocolo }}</span>
                                <span><b>Data Protesto:</b> {{ titulo.dt_ocorrencia }}</span>
                                <span><b>Data Emissão:</b> {{ titulo.dt_emissao }}</span>
                                <span><b>Data Vencimento:</b> {{ titulo.dt_vencimento }}</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
            <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')" >Fechar</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '../../services/api';
export default {
    props:{
        nrPedidoAnuencia : '',
        anuenciaDados:{},
    },
    methods: {
        getCancelamentoDetalhe(){
            this.loading = true;
            this.token = localStorage.getItem('jwtToken');
            this.carregando = true;
            this.loading = false;
            this.carregando = false;
        },
        devolveResposta(resposta) {
            this.loading = true;
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-anuencia-detalhe');
        },
        cleanModal(){
            this.nrPedidoAnuencia = null;
            this.anuenciaDados = {};
        },
        // #region funções auxiliares para montar a apresentação de valores
        formatDataHoraToData(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora.split(' ')[0];
        },
        formatDataHora(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora;
        },
        formatData(string){
            return string ? string.split('-').reverse().join('/') : '';
        },
        formatDocumento(string) {
            if (string == null) {
                return '';
            } else {
                let v = string;
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                            .replace(/\.(\d{3})(\d)/, ".$1/$2")
                            .replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
        },
        formatCep(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{3})\d+?$/, '$1');
        },
        formatPhone(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{2})(\d)/, '($1) $2')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{4})\d+?$/, '$1');
        },
        formatRg(string){
            if (string == null) return '';
            else return string.replace(/\D/g,"")
                            .replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/,"$1.$2.$3-$4");
        },
        // #endregion
        // #region downloads
        downloadAnuencia(arquivo, cd_anuencia){
            if(arquivo){
                let link = document.createElement('a');
                let nomeArquivo = 'anuencia_' + cd_anuencia + '.pdf';
                link.href = "data:application/pdf;base64," + arquivo.pdf;
                link.setAttribute('download', nomeArquivo);
                link.click();
            }
        },
        downloadAnexoAnuencia(arquivo, cd_anuencia){
            if(arquivo){
                let link = document.createElement('a');
                let nomeArquivo = 'anuencia_' + cd_anuencia + '_anexo.pdf';
                link.href = "data:application/pdf;base64," + arquivo.pdf_anexo;
                link.setAttribute('download', nomeArquivo);
                link.click();
            }
        },
        downloadPDF(cd_anuencia, tipoArquivo) {
            this.carregando = true;
            const token = localStorage.getItem("jwtToken");
            API.post("anuencia/pdfPedidoAnexo", {cd_anuencia_titulo: cd_anuencia,token,}).then((res) => {
                this.carregando = false;
                if(tipoArquivo == 'anuencia') this.downloadAnuencia(res.data.dados, cd_anuencia);
                if(tipoArquivo == 'anexo') this.downloadAnexoAnuencia(res.data.dados, cd_anuencia);
            }).catch(() => {
                alert("Falha ao realizar o Download");
                this.carregando = false;
                return false;
            });
        },
        // #endregion
    },
    data(){
        return{
            loading:false,
            error:false,
            resposta: 's',
            currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
            modalAnuenciaOk:false,
            statusGerarLote: [1, 13, 15],
            carregando: false,
            token:'',
        }
    },
    computed:{
        nrPedido(){
            if(this.nrPedidoAnuencia !== undefined && this.nrPedidoAnuencia !== null) return this.nrPedidoAnuencia.toLocaleString();
            else return '';
        },
        titulo(){
            if(this.anuenciaDados !== undefined && this.anuenciaDados !== null){
                let tituloDados     = this.anuenciaDados;                
                let titulo          = {
                    nm_nr_documento_devedor: this.formatDocumento(tituloDados.documento_devedor),
                    vl_titulo: this.currencyFormatter.format(tituloDados.vl_titulo),
                    vl_protesto: this.currencyFormatter.format(tituloDados.vl_protesto),
                    nm_nosso_numero: tituloDados.nm_nosso_numero,
                    nm_nr_titulo: tituloDados.nm_nr_titulo,
                    nm_devedor: tituloDados.nm_devedor,
                    nm_nr_protocolo: tituloDados.nm_nr_protocolo,
                    dt_protocolo: this.formatData(tituloDados.dt_protocolo),
                    dt_ocorrencia: this.formatData(tituloDados.dt_ocorrencia),
                    dt_emissao: this.formatData(tituloDados.dt_emissao),
                    dt_vencimento: this.formatData(tituloDados.dt_vencimento),
                };
                return titulo;
            }
            else return {}
        },
        anuencia(){
            if(this.anuenciaDados !== undefined && this.anuenciaDados !== null){
                let pedidoAnuenciaDados     = this.anuenciaDados;                
                let anuencia                = {
                    vl_custas: this.currencyFormatter.format(pedidoAnuenciaDados.vl_custas),
                    dt_cadastro: this.formatDataHora(pedidoAnuenciaDados.dt_cadastro),
                    cd_anuencia: pedidoAnuenciaDados.cd_anuencia,
                    ds_status: pedidoAnuenciaDados.ds_status,
                    anexo_anuencia: (pedidoAnuenciaDados.anexo_anuencia == 'true'),
                    ic_origem_anuencia: pedidoAnuenciaDados.ic_origem_anuencia,
                    cd_status: pedidoAnuenciaDados.cd_status,
                    motivo_recusa: pedidoAnuenciaDados.motivo_recusa,
                };
                return anuencia;
            }
            else return {}
        },
        cartorio(){
            if(this.anuenciaDados !== undefined && this.anuenciaDados !== null){
                let cartorioDados   = this.anuenciaDados;                
                let cartorio        = {
                    documento_cartorio: this.formatDocumento(cartorioDados.documento_cartorio),
                    telefone_cartorio: this.formatPhone(cartorioDados.telefone_cartorio),
                    nome_cartorio: cartorioDados.nome_cartorio,
                    email_cartorio: cartorioDados.email_cartorio,
                };
                return cartorio;
            }
            else return {}
        },
        solicitante(){
            if(this.anuenciaDados !== undefined && this.anuenciaDados !== null){
                let solicitanteDados    = this.anuenciaDados;                
                let solicitante         = {
                    documento_solicitante: this.formatDocumento(solicitanteDados.documento_solicitante),
                    telefone_solicitante: this.formatPhone(solicitanteDados.telefone_solicitante),
                    celular_solicitante: this.formatPhone(solicitanteDados.celular_solicitante),
                    nm_solicitante: solicitanteDados.nm_solicitante,
                    nm_email_solicitante: solicitanteDados.nm_email_solicitante,
                };
                return solicitante;
            }
            else return {}
        },
    },
    mounted(){
    },
    watch:{
        nrPedidoAnuencia(val){
            if(val !== undefined && val !== '' && val !== null)
                this.modalAnuenciaOk = true;
            else
                this.modalAnuenciaOk = false;
        },
        modalAnuenciaOk(val){
            if(val){
                this.getCancelamentoDetalhe();
            }
        },
    }
}
</script>
<style scoped>

.modal-card{
    display: flex;
    flex-flow: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}

h5 {
    font: normal normal 200 25px/25px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    margin: 0px;
}
h3 {
    font: normal normal 200 20px/18px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    color:var(--secondary-color) !important;
    margin: 0px;
}
span{
    margin-bottom: 18px;
    font: normal normal 200 16px/17px 'Kanit', sans-serif;
    letter-spacing: -1%;
}
.modal-card-body{
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-left{max-width: 370px;}
.card-column-left .modal-card-body{gap: 0;}
.card-column-right{max-width: calc(100% - 370px)}
.card-column-left .modal-card-body span{
    flex: 1 1 100%;
    max-width: 100%;
}
.card-column-right .modal-card-body .row-body{
    flex: 1 1 95%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-right .modal-card-body .row-body span{
    flex: 1 1 32%;
    max-width: 32%;
}
.card-column-right .modal-card-body > span{
    flex: 1 1 49%;
    max-width: 49%;
}
.btn.btn-success{
    width: 160px;
    height: 44px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: none;
    outline: none;
}
hr{width: 100%;margin-bottom: 1rem;}


@media (max-width:1199px) {
    
    .card-column-left{max-width: unset;}
    .card-column-right{max-width: unset;}
    .card-column-right .modal-card-body > span{flex: 1 1 100%;max-width: 100%;}
    .card-column-right .modal-card-body .row-body span{flex: 1 1 100%;max-width: 100%;}
    .btn.download-ted{width: 100%;}
}
</style>